import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';
import Session from 'mewe/shared/session';

// deprecated - to be removed after some grace period
export default class EventSinglePostRoute extends Route {
  @service router;

  async beforeModel(transition) {
    const params = transition.to.params;
    if (params?.post_id) {
      Session.isAuthenticated().then(({ isAuthenticated }) => {
        if (isAuthenticated) {
          this.router.transitionTo('app.myworld.single-post', params.post_id, {
            queryParams: { eventId: params.event_id },
          });
        } else {
          window.location.href = `/login?next=/post/show/${params.post_id}&eventId=${params.event_id}`;
        }
      });
    }
  }
}
